import React, { FunctionComponent, memo } from "react";
import { Button } from "@mui/material";

import { NewTabIcon } from "assets";
import { getUtilityBillById } from "api";
import { setToLocalStorage } from "utils";
import { AlertBanner } from "components";

import { UTILITY_BILL_PAGE } from "../../../route-consts";
import { AnomalyProps } from "./types";

const WARNING_FOOTER = (
  <>
    Please <span style={{ color: "#E21515" }}>review the data</span> and make
    any necessary corrections, or click &quot;Confirm Data&quot; if everything
    is accurate.
  </>
);

export const Anomaly: FunctionComponent<AnomalyProps> = memo(
  ({ anomalyType, message, bgColor, previousBillGuid, notify }) => {
    const handlePreviousBillCardClick = async (id: string) => {
      if (id) {
        try {
          const response = await getUtilityBillById(id);
          setToLocalStorage(
            "document",
            JSON.stringify({
              documentGuid: response.documentGuid,
              filename: response.filename,
            }),
          );

          window.open(
            `${UTILITY_BILL_PAGE.ABSOLUTE_PATH(previousBillGuid as string)}`,
            "_blank",
          );
        } catch (error) {
          console.error("Error fetching utility bill:", error);
          notify?.error(
            "This bill no longer exists. It may have been deleted.",
          );
        }
      }
    };

    const action = previousBillGuid ? (
      <Button
        sx={{
          minWidth: "24px",
          height: "24px",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          paddingRight: "4px",
        }}
        onClick={() => handlePreviousBillCardClick(previousBillGuid as string)}
      >
        <NewTabIcon />
      </Button>
    ) : undefined;

    return (
      <AlertBanner
        variant="warning"
        title={`Verification Failed | ${anomalyType}`}
        message={message as string}
        bgColor={bgColor as string | undefined}
        action={action}
        footer={WARNING_FOOTER}
      />
    );
  },
);
